import { render, staticRenderFns } from "./No06.vue?vue&type=template&id=459e207a&scoped=true"
import script from "./No06.vue?vue&type=script&lang=js"
export * from "./No06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e207a",
  null
  
)

export default component.exports